import HomeIcon from '@mui/icons-material/Home';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import GroupIcon from '@mui/icons-material/Group';
import LockResetIcon from '@mui/icons-material/LockReset';
import SettingsIcon from '@mui/icons-material/Settings';

import CustomerView from "app_tiles/Customers/CustomersView";
import ResetPassword from 'app_tiles/ResetPassword';
import ProbeTable from 'app_tiles/Probes/ProbeTable';
import SsoForm from 'app_tiles/Customers/SsoForm';
import LicenseDetails from 'app_tiles/Licenses/LicenseDetails';
import UserManagement from 'app_tiles/MonitorUsers/UserManagement';
import LiveProbesViewers from 'app_tiles/Customers/LiveProbesViewers';
import ProbeStreamingActivity from 'app_tiles/Customers/ProbeStreamingActivity';
import ProbeViewerActivity from 'app_tiles/Customers/ProbeViewerActivity';
import DataConsumptionView from 'app_tiles/DataConsumption/DataConsumptionView';
import UserActivity from 'app_tiles/UserActivity/CustomersUserActivity';
import ProbeActivity from 'app_tiles/Probes/ProbeActivity';

const dashboardRoutes = [
  {
    path: "/customers",
    name: "Customers",
    rtlName: "",
    icon: GroupIcon,
    layout: "/dealeroperator",
    children: [
      {
        path: "/list",
        param: "Customers",
        name: "Customers List",
        rtlName: "",
        icon: SettingsIcon,
        component: CustomerView,
      },
      {
        path: "/probes",
        param: "Show Probes",
        name: "Probes",
        rtlName: "",
        icon: SettingsIcon,
        component: ProbeTable,
      },
      {
        path: "/license-management",
        param: "License Management",
        name: "License Management",
        rtlName: "",
        icon: SettingsIcon,
        component: LicenseDetails,
      },
      {
        path: "/user-management",
        param: "User Management",
        name: "User Management",
        rtlName: "",
        icon: SettingsIcon,
        component: UserManagement,
      },
      {
        path: "/sso-settings",
        param: "SSO Settings",
        name: "SSO Settings",
        rtlName: "",
        icon: SettingsIcon,
        component: SsoForm,
      },
      {
        path: "/live-probes-viewers",
        param: "Live Probes Viewers",
        name: "Live Viewers",
        rtlName: "",
        icon: SettingsIcon,
        component: LiveProbesViewers,
      },
      // {
      //   path: "/probe-streaming-activity",
      //   param: "Probe Streaming Activity",
      //   name: "Probe Streaming Activity",
      //   rtlName: "",
      //   icon: SettingsIcon,
      //   component: ProbeStreamingActivity,
      // },
      // {
      //   path: "/probe-viewer-activity",
      //   param: "Probe Viewer Activity",
      //   name: "Probe Viewer Activity",
      //   rtlName: "",
      //   icon: SettingsIcon, 
      //   component: ProbeViewerActivity,
      // },
      {
        path: "/data-consumption",
        param: "Data Consumption",
        name: "Data Consumption",
        rtlName: "",
        icon: SettingsIcon,
        component: DataConsumptionView, 
      },
      {
        path: "/user-activity",
        param: "User Activity",
        name: "User Activity",
        rtlName: "",
        icon: SettingsIcon,
        component: UserActivity,
      },
      {
        path: "/probe-activity",
        param: "Probe Activity",
        name: "Probe Activity",
        rtlName: "",
        icon: SettingsIcon,
        component: ProbeActivity,
      }

    ],
  },
  {
    path: "/resetPassword",
    name: "Reset Password",
    rtlName: "",
    icon: LockResetIcon,
    component: ResetPassword,
    layout: "/dealeroperator",
    children: []
  },
  {
    path: "/login",
    name: "Logout",
    rtlName: "",
    icon: ExitToAppIcon,
    children: []
  },

];

export default dashboardRoutes;